import React from "react"
import "./EditableBanner.scss"
import { getImageUrl } from "../../services/Utils"

const EditableBanner = ({ text, bannerBackgroundImage }) => {
  const bgUrl = bannerBackgroundImage ? getImageUrl(bannerBackgroundImage) : null

  if (!bgUrl && !text) {
    return null
  }

  return (
    <div
      className="hero-section d-flex align-items-start"
      style={
        bgUrl
          ? {
              background: `url(${bgUrl}) no-repeat center center`,
              backgroundSize: "cover",
            }
          : {}
      }
    >
      <div className="col hero-section__content-wrapper">
        {text && (
          <div
            className="hero-section__text"
            dangerouslySetInnerHTML={{ __html: text }}
          ></div>
        )}
      </div>
    </div>
  )
}

export default EditableBanner
